import isEqual from 'react-fast-compare';
import { FilterToolbarItem, FilterToolbarItemId } from 'src/components/Filters';
import { CurrencyFilterMultiSelector } from 'src/components/Selectors/CurrencyFilterSelector';
import { ContentId } from 'src/utils/constants/contentId';

type CurrencyCodesFilter = {
  currencyCodes: string[] | null;
};

export const usePurchaseCurrencyCodesFilters = <
  TFilter extends CurrencyCodesFilter,
>({
  query,
  setQuery,
}: {
  query: TFilter;
  setQuery: (query: TFilter) => void;
}): FilterToolbarItem => {
  return {
    filterId: 'currencyCodes' as FilterToolbarItemId,
    labelContentId: ContentId.Currency,
    filterQueryKeys: ['currencyCodes'] as FilterToolbarItemId[],
    filterItem: (
      <CurrencyFilterMultiSelector
        triggerProps={{ style: { width: '100%' } }}
        values={query.currencyCodes ?? []}
        placeholderText={ContentId.All}
        onChange={({ newValues: newCurrencyCodes }) => {
          if (!isEqual(query.currencyCodes, newCurrencyCodes)) {
            setQuery({
              ...query,
              currencyCodes: newCurrencyCodes?.length ? newCurrencyCodes : null,
            });
          }
        }}
        enableEmptySelection
      />
    ),
  };
};
